import React from 'react';
import { TextField, TextDescription } from '@ann/web-components';

const BasicInfoSection = ({
  name,
  description,
  onNameChange,
  onDescriptionChange,
}) => {
  return (
    <>
      <TextField
        label="Agent Name"
        placeholder="Enter agent name"
        value={name}
        onChange={onNameChange}
        size="small"
      />

      <TextDescription
        height="148px"
        label="Description (optional)"
        value={description}
        onChange={onDescriptionChange}
        placeholder="Briefly describe this agent purpose or function"
        size="small"
      />
    </>
  );
};

export default BasicInfoSection;

